<div class="container">
  <div
    [ngClass]="fullWidth ? 'itinerary-container-full' : 'itinerary-container-responsive'"
    class="itinerary-container"
    *ngIf="itinerary"
  >
    <h2 *ngIf="!routeGrabbed && fullWidth">
      {{ itinerary.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
    </h2>
    <route-itinerary-date-selector
      [routeId]="primaryRouteId"
      (selectedRouteChange)="dateChangedInRouteItineraryComponent($event)"
      *ngIf="!hideDateSelector && primaryRouteId && !routeGrabbed"
    ></route-itinerary-date-selector>
    <route-itinerary-header [itinerary]="itinerary"></route-itinerary-header>
    <route-itinerary-alert
      *ngIf="visibleAlerts.length"
      [alerts]="visibleAlerts"
    ></route-itinerary-alert>
    <route-itinerary-day-break
      [currentDayNumber]="1"
      [totalDays]="itinerary.carryOverCount + 1"
      [dayDate]="itinerary.leaveHomeEarliest"
      [fullWidth]="fullWidth"
    >
    </route-itinerary-day-break>
    <route-itinerary-vertical-dots-container [noIcon]="true" position="start">
      <div left>
        <route-itinerary-direction-link
          [label]="'Start'"
          [showDirectionLink]="!!itinerary.supplierToTaskSegment.googleMapDirection"
          (viewDirectionLink)="
            openExternalLink(itinerary.supplierToTaskSegment.googleMapDirection?.directionUrl)
          "
        ></route-itinerary-direction-link>
      </div>
      <div right>
        <route-itinerary-start-end-detail
          [travelPosition]="RouteItineraryTravelPosition.Start"
          [segment]="itinerary.supplierToTaskSegment"
          [itinerary]="itinerary"
        ></route-itinerary-start-end-detail>
        <div class="med-width-border"></div>
        <route-itinerary-travel-guide
          [transportInfo]="itinerary.supplierToTaskSegment"
        ></route-itinerary-travel-guide>
      </div>
    </route-itinerary-vertical-dots-container>

    <div class="med-width-border"></div>

    <ng-container *ngFor="let recommendedTask of itinerary?.recommendationTasks; let i = index">
      <route-itinerary-vertical-dots-container [noIcon]="true" position="middle">
        <div left>
          <route-itinerary-task-detail
            [task]="recommendedTask"
            [expanded]="expandedTaskIndex === i"
            (expanderToggle)="toggleTaskExpander(i)"
            (viewDirectionLink)="viewTaskDirections(i)"
          ></route-itinerary-task-detail>
        </div>
        <div right>
          <route-itinerary-task-address-detail
            [task]="recommendedTask"
            [supplier]="itinerary.supplierDetail"
            [carryOverToHome]="recommendedTask.hasCarryover"
          ></route-itinerary-task-address-detail>
        </div>
      </route-itinerary-vertical-dots-container>

      <route-itinerary-task-expander
        [task]="recommendedTask"
        [expanded]="expandedTaskIndex === i"
        [taskNumber]="i + 1"
      ></route-itinerary-task-expander>

      <ng-container *ngIf="recommendedTask.hasCarryover">
        <route-itinerary-day-break
          [currentDayNumber]="1 + getCarryOverSequenceNumber(i)"
          [totalDays]="itinerary.carryOverCount + 1"
          [dayDate]="recommendedTask.taskCarryover.leaveHomeEarliest"
          [isCarryoverDay]="true"
          [fullWidth]="fullWidth"
        >
        </route-itinerary-day-break>
        <route-itinerary-vertical-dots-container [noIcon]="true" position="middle">
          <div left>
            <route-itinerary-direction-link
              [label]="'Continue'"
              [showDirectionLink]="true"
              (viewDirectionLink)="openCarryoverReturnLink(i)"
            ></route-itinerary-direction-link>
          </div>
          <div right>
            <route-itinerary-task-address-detail
              [task]="recommendedTask"
              [supplier]="itinerary.supplierDetail"
              [carryOverFromHome]="true"
            ></route-itinerary-task-address-detail>
          </div>
        </route-itinerary-vertical-dots-container>
      </ng-container>

      <div [class]="expandedTaskIndex === i ? 'full-width-border' : 'med-width-border'"></div>

      <route-itinerary-vertical-dots-container
        [noIcon]="true"
        position="middle"
        *ngIf="i + 1 < itinerary.recommendationTasks.length"
      >
        <div left>
          <route-itinerary-direction-link
            [label]="'Change Task'"
            [showDirectionLink]="!!itinerary.taskToTaskSegments[i].googleMapDirection"
            (viewDirectionLink)="
              openExternalLink(itinerary.taskToTaskSegments[i].googleMapDirection?.directionUrl)
            "
          ></route-itinerary-direction-link>
        </div>
        <div right>
          <route-itinerary-travel-guide
            [transportInfo]="itinerary.taskToTaskSegments[i]"
          ></route-itinerary-travel-guide>
        </div>
      </route-itinerary-vertical-dots-container>

      <div class="med-width-border" *ngIf="i + 1 < itinerary?.recommendationTasks?.length"></div>
    </ng-container>

    <route-itinerary-vertical-dots-container [noIcon]="true" position="middle">
      <div left>
        <route-itinerary-direction-link
          [label]="'Getting Home'"
          [showDirectionLink]="!!itinerary.taskToSupplierSegment.googleMapDirection"
          (viewDirectionLink)="
            openExternalLink(itinerary.taskToSupplierSegment.googleMapDirection?.directionUrl)
          "
        ></route-itinerary-direction-link>
      </div>
      <div right>
        <route-itinerary-travel-guide
          [transportInfo]="itinerary.taskToSupplierSegment"
        ></route-itinerary-travel-guide>
      </div>
    </route-itinerary-vertical-dots-container>

    <route-itinerary-vertical-dots-container [noIcon]="true" position="end">
      <div left>
        <route-itinerary-direction-link
          [label]="'End'"
          [showDirectionLink]="false"
        ></route-itinerary-direction-link>
      </div>
      <div right>
        <route-itinerary-start-end-detail
          [travelPosition]="RouteItineraryTravelPosition.End"
          [segment]="itinerary.taskToSupplierSegment"
          [itinerary]="itinerary"
        ></route-itinerary-start-end-detail>
      </div>
    </route-itinerary-vertical-dots-container>
  </div>
</div>
